export var Atom = function Atom(props) {
  return props.children || null;
};
Atom.__rtm_atom = true;
export var isAtomComponent = function isAtomComponent(reactEl) {
  return !!(reactEl && reactEl.type && reactEl.type.__rtm_atom === true);
};
export var ATOM_STRING_ID = '<Atom>';